module.exports = __webpack_public_path__ + "static/img/ent-detail-8.f51a9b9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-detail-8.jpg
// module id = nscr
// module chunks = 52